import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  Tooltip,
  IconButton,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

// budget เดิมที่ไม่มี approval_status ถือว่าอนุมัติแล้ว
const APPROVAL_STATUS = {
  PENDING: { th: 'รออนุมัติ', en: 'Pending', color: 'warning' },
  APPROVED: { th: 'อนุมัติ', en: 'Approved', color: 'success' },
  REJECTED: { th: 'ปฏิเสธ', en: 'Rejected', color: 'error' },
};

export default function BudgetListTable({
  budget,
  handleEditBudget,
  handleDeleteBudget,
  uiLang = 'en',
}) {
  const U = (th, en) => (uiLang === 'en' ? en : th);
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small">
        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('เลขงบประมาณ', 'Budget Number')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('ชื่อ', 'Name')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }} align="right">
              {U('งบประมาณ', 'Cost')}
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('รายละเอียด', 'Description')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('สถานะ', 'Status')}</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>{U('จัดการ', 'Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {budget && Array.isArray(budget) && budget.length > 0 ? (
            budget.map((item, index) => {
              const st = APPROVAL_STATUS[item.approval_status] || APPROVAL_STATUS.APPROVED;
              const rejectedTip = item.approval_status === 'REJECTED'
                ? [item.approval_by_name, item.approval_reason].filter(Boolean).join(' : ')
                : '';
              return (
                <TableRow
                  key={item._id || index}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#fafafa',
                    },
                  }}
                >
                  <TableCell>{item.budget_number}</TableCell>
                  <TableCell>{item.name}</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 500 }}>
                    {item.cost?.toLocaleString('th-TH', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>
                  <TableCell sx={{ color: '#666' }}>{item.description}</TableCell>
                  <TableCell>
                    <Tooltip title={rejectedTip}>
                      <Chip
                        size="small"
                        color={st.color}
                        variant="outlined"
                        label={U(st.th, st.en)}
                        sx={{ height: 22, fontSize: '0.75rem' }}
                      />
                    </Tooltip>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="edit"
                      size="small"
                      onClick={() => handleEditBudget(item)}
                    >
                      <ModeEditIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={() => handleDeleteBudget(item)}
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell
                colSpan={6}
                align="center"
                sx={{ color: '#999', py: 3 }}
              >
                {U('ไม่มีข้อมูล', 'No data')}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
